import { LOCALE_ID, inject, provideAppInitializer } from '@angular/core';
import { MaintenanceService } from './core/http/maintenance.service';
import { maintenanceInterceptor } from './core/http/maintenance.interceptor';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import { provideServiceWorker } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { credentialsInterceptor } from './core/http/credentials.interceptor';

registerLocaleData(localeEs);

export const appConfig: ApplicationConfig = {
  providers: [
    provideAppInitializer(() => inject(MaintenanceService).check()),
    { provide: LOCALE_ID, useValue: 'es-ES' },
    provideZonelessChangeDetection(),
    provideServiceWorker('ngsw-worker.js', {
      enabled: environment.pwaEnabled,
      registrationStrategy: 'registerWhenStable:30000',
    }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withFetch(),
      withInterceptors([maintenanceInterceptor, credentialsInterceptor])
    ),
  ],
};
